import {
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  required,
  email,
  ReferenceInput,
  AutocompleteInput,
  maxLength,
  NumberInput,
  minValue,
} from "react-admin";
import { Grid, Typography } from "@mui/material";
import { phoneValidator } from "utils/validations";
import { MembersIteratorItem } from "server/components/Fields/MemberFields";
import { useWatch } from "react-hook-form";
import { administrationRequests } from "api/administrationApi";
import { settings } from "app";
import { specialistRequests } from "api/specialistApi";

const CreateForm = () => {
  const buildingId = useWatch({ name: "contact.buildingId" });
  const universityId = useWatch({ name: "contact.universityId" });

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="specializationId"
          reference={specialistRequests.getSpecializationsSelect()}
        >
          <AutocompleteInput
            optionText="nameBg"
            label="Специалност"
            fullWidth
            validate={[required()]}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="name"
          label="Име на изпитна комисия"
          validate={[required(), maxLength(300)]}
          fullWidth
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={4}
      >
        <NumberInput
          source="year"
          label="Година"
          validate={[required(), minValue(2025)]}
          onWheel={e => e.target.blur()}
        />
      </Grid>
      <Grid
        item
        xs={12}
      >
        <ArrayInput
          source="members"
          label="Членове"
          defaultValue={[{}]}
        >
          <SimpleFormIterator
            inline={false}
            sx={settings.style.iteratorWithoutGap}
          >
            <MembersIteratorItem />
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>

      <Grid
        item
        xs={12}
      >
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <Typography
              sx={{ marginTop: 3 }}
              color="primary"
            >
              Контакт
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <TextInput
              source="contact.address"
              label="Адрес"
              fullWidth
              validate={[required(), maxLength(500)]}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <TextInput
              source="contact.email"
              label="Имейл"
              fullWidth
              validate={[required(), email(), maxLength(256)]}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <TextInput
              source="contact.phoneNumber"
              label="Телефон"
              fullWidth
              validate={[required(), phoneValidator, maxLength(50)]}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <TextInput
              source="contact.mobilePhoneNumber"
              label="Мобилен телефон"
              fullWidth
              validate={[required(), phoneValidator, maxLength(50)]}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <ReferenceInput
              source="contact.buildingId"
              reference={administrationRequests.getBuildingsSelect()}
              label="Сграда"
            >
              <AutocompleteInput
                label="Сграда"
                optionText="name"
                optionValue="id"
                filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                disabled={!!universityId}
                validate={universityId ? "" : required()}
              />
            </ReferenceInput>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <ReferenceInput
              source="contact.universityId"
              reference={administrationRequests.getUniversitiesSelect()}
              label="Университет"
            >
              <AutocompleteInput
                label="Университет"
                optionText="name"
                optionValue="id"
                filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                disabled={!!buildingId}
                validate={buildingId ? "" : required()}
              />
            </ReferenceInput>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CreateForm;
